<script lang="ts">
  import Header from "./components/0-Header.svelte";
  import Intro from "./components/1-Intro.svelte";
  import Abstraction from "./components/2-Abstraction.svelte";
  import Efficiency from "./components/3-Efficiency.svelte";
  import Scale from "./components/4-Scale.svelte";
  import Conclusion from "./components/5-Conclusion.svelte";
  import Footer from "./components/6-Footer.svelte";
</script>

<svelte:head>
  <title>Seeing Like a Software</title>
  <link rel="preconnect" href="https://fonts.googleapis.com" />
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin="true" />
  <link href="https://fonts.googleapis.com/css2?family=Crimson+Text:ital@0;1&display=swap" rel="stylesheet">
  <link href="https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;700&display=swap" rel="stylesheet">
</svelte:head>

<Header />
<Intro />
<Abstraction />
<Efficiency />
<Scale />
<Conclusion />
<Footer />